<template>
  <div class="container mt-4">
    <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/">
        <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item
      >
      <b-breadcrumb-item href="/residentslist-doc">
        Residents</b-breadcrumb-item
      >
      <b-breadcrumb-item active> {{ getBread("-doc") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">
      <h1 style="font-size: 2rem; text-align: center; padding-bottom: 1rem">
        List of Documents {{ fullName }}
      </h1>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <div v-if="getUserRole('admins')">
        <button class="btn btn-primary mb-4" @click="showAddModal = true">
          Add Document
        </button>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Document Name</th>
            <th scope="col">Expiring Date</th>
            <th scope="col">Description</th>
            <th scope="col">Document type</th>
            <th
              scope="col"
              v-if="getUserRole('admins') || getUserRole('editors')"
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in paginatedDocuments" :key="document.id">
            <td>
              {{ document.attributes.documentname }}
            </td>
            <td>{{ formatDate(document.attributes.expiredate) }}</td>
            <td>{{ document.attributes.description }}</td>
            <td>{{ getDocumentTypeText(document.attributes.documenttype) }}</td>
            <td v-if="getUserRole('admins') || getUserRole('editors')">
              <a href="#" @click.prevent="editEntry(document)">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residentdocuments.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal
      size="xl"
      v-model="showEditModal"
      hide-footer
      :title="'Edit Document ' + fullName"
    >
      <form v-if="currentDocument" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="documentname" class="form-label">Document Name</label>
              <input
                type="text"
                class="form-control"
                id="documentname"
                v-model="currentDocument.attributes.documentname"
                required
              />
            </div>

            <div class="mb-3">
              <label for="description" class="form-label">Description</label>
              <textarea
                class="form-control"
                id="description"
                v-model="currentDocument.attributes.description"
                required
              ></textarea>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="documenttype" class="form-label"
                >Docomment Type</label
              >
              <select
                class="form-select"
                id="documenttype"
                v-model="currentDocument.attributes.documenttype"
                required
              >
                <option
                  v-for="option in documentTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="col-md-4"></div>
            <div class="mb-3">
              <label for="expiredate" class="form-label">Expiring Date</label>
              <input
                type="date"
                class="form-control"
                id="expiredate"
                v-model="currentDocument.attributes.expiredate"
                required
              />
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

    <!-- Add Modal -->
    <b-modal
      v-model="showAddModal"
      hide-footer
      :title="'Add Document ' + fullName"
    >
      <form @submit.prevent="addEntry">
        <div class="mb-3">
          <label for="documentname" class="form-label">Document Name</label>
          <input
            type="text"
            class="form-control"
            id="documentname"
            v-model="newDocument.documentname"
            required
          />
        </div>
        <div class="mb-3">
          <label for="expiredate" class="form-label">Expiring Date</label>
          <input
            type="date"
            class="form-control"
            id="expiredate"
            v-model="newDocument.expiredate"
            required
          />
        </div>
        <div class="mb-3">
          <label for="description" class="form-label">Description</label>
          <textarea
            class="form-control"
            id="description"
            v-model="newDocument.description"
            required
          ></textarea>
        </div>
        <div class="mb-3">
          <label for="documenttype" class="form-label">Document Type</label>
          <select
            class="form-select"
            id="documenttype"
            v-model="newDocument.documenttype"
            required
          >
            <option
              v-for="option in documentTypes"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="d-grid">
          <button type="submit" class="btn btn-primary">Add Document</button>
        </div>
      </form>
      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import {
  GET_DOCUMENTS_BY_RESIDENT,
  UPDATE_DOCUMENT,
  GET_FULLNAME_BY_ID,CREATE_DOCUMENT
} from "../hooks/queries";
import { ref, computed } from "vue";
import { documentTypes, getBread, getUserRole } from "../components/values";
import { useRoute } from "vue-router"; // Import useRoute from Vue Router

export default {
  name: "App",

  setup() {
    const route = useRoute(); // Use useRoute to get the current route
    const residentId = route.params.id; // Access the route parameter directly
    const { result:result, loading:loading, error:error, refetch:refetch } = useQuery(
      GET_DOCUMENTS_BY_RESIDENT,
      { residentId: residentId }
    );

    const {result:resultfullname, loading:loadingfullname, error:errorfullname, refetch:refetchfullname } = useQuery(GET_FULLNAME_BY_ID, {
      id: residentId,
    });

      // Watch the result and compute the full name only when the data is available
      const fullName = computed(() => {
      const data = resultfullname.value?.resident?.data;
      if (data) {
        return `(${data.attributes.firstname} ${data.attributes.lastname})`;
      }
      return null;
    });

    const { mutate: updateResidentdocument } = useMutation(UPDATE_DOCUMENT);
    const { mutate: createDocument } = useMutation(CREATE_DOCUMENT);
    const currentDocument = ref(null);
    const updateError = ref(null);
    const addError = ref(null);
    const showEditModal = ref(false);
    const showAddModal = ref(false);

    const newDocument = ref({
      documentname: "",
      expiredate: "",
      documenttype: "",
      description: "",
      publishedAt: new Date().toISOString(),
    });

    const addEntry = async () => {
      addError.value = null;
      try {
        await createDocument({
          data: {
            resident: residentId, // Include the residentId in the input data
            documentname: newDocument.value.documentname,
            documenttype: newDocument.value.documenttype,
            expiredate: newDocument.value.expiredate,
            description: newDocument.value.description,
            publishedAt: new Date().toISOString(),
          },
        });
        showAddModal.value = false;
        newDocument.value = {
          documentname: "",
          expiredate: "",
          documenttype: "",
          description: "",
        };
        await refetch(); // Refetch the list of documents after adding a new one
        await refetchfullname();
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add document. Please try again.}`;
      }
    };

    const formatDate = (date) => {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    };

    const editEntry = (document) => {
      //currentDocument.value = { ...document }; // Copy document to avoid directly modifying the original data
      currentDocument.value = JSON.parse(JSON.stringify(document)); // Create a deep copy of the docuement object
      showEditModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResidentdocument({
          id: currentDocument.value.id,
          data: {
            documentname: currentDocument.value.attributes.documentname,
            documenttype: currentDocument.value.attributes.documenttype,
            expiredate: currentDocument.value.attributes.expiredate,
            description: currentDocument.value.attributes.description,
          },
        });
        //console.log("Updated entry:", currentDocument.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update Document. Please try again.";
      }
    };

    const getDocumentTypeText = (value) => {
      const option = documentTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    return {
      result,
      loading,
      error,
      formatDate,
      showEditModal,
      showAddModal,
      currentDocument,
      newDocument,
      editEntry,
      updateEntry,
      addEntry,
      updateError,
      addError,
      documentTypes,
      getDocumentTypeText,
      getUserRole,
      getBread,
      residentId,
      errorfullname,
      loadingfullname,
      fullName,
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.result.residentdocuments.data.length / this.itemsPerPage
      );
    },
    paginatedDocuments() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residentdocuments.data.slice(
        start,
        start + this.itemsPerPage
      );
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residentdocuments.data.length
      );
    },
 
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>
  
  <style>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
</style>
  
